<template>
  <div
    v-if="!noHealth"
    class="organ"
    :style="{ backgroundImage: 'url(' + ossUrl + '/diseasaBg.png)' }"
  >
    <TopTabBar :tab-list="tabs" @change="changeTab" />
    <!-- 健康总评 -->
    <total-list
      v-if="activeIndex == 0"
      :list="specials"
      :marks="marks"
    ></total-list>
    <DiseasaOrgan v-if="activeIndex == 1" :list="datas" />
    <organ-model
      v-if="activeIndex == 2"
      :organ-list="diseasalist"
      report-type="risk"
    >
    </organ-model>
  </div>
</template>
<script>
import { ossUrl } from "@/config";
import Report from "../../models/Report";
import OrganModel from "@/components/OrganModel";
import TopTabBar from "@/components/TopTabBar";
import TotalList from "@/components/TotalList";
import DiseasaOrgan from "@/components/DiseasaOrgan";
import { tabs } from "@/utils/tabs";
export default {
  name: "RiskReport",
  components: { OrganModel, TopTabBar, TotalList, DiseasaOrgan },
  data() {
    return {
      ossUrl,
      tabs: tabs.diseasa,
      noHealth: true, //是否有检测数据
      activeIndex: 0, //当前显示 0 人体 ，1 脊椎
      diseasalist: [], //人体器官
      specials: [], //列表
      sex: 2, //性别,
      marks: "", //当前报告分数，
      datas: {},
      abcd: {},
    };
  },
  computed: {
    id() {
      return this.$route.query.id || "";
    },
    user_no() {
      return this.$route.query.user_no || "";
    },
  },
  created() {
    this.getReport();
  },
  methods: {
    changeTab(val) {
      this.activeIndex = val;
    },
    /** 对象转数组 */
    objToArray(obj) {
      let arr = [];
      for (const key in obj) {
        if (obj[key].name) {
          arr.push({ title: key, ...obj[key] });
        }
      }
      return arr;
    },
    compare(property) {
      return function (a, b) {
        const value1 = a[property];
        const value2 = b[property];
        return value1 - value2;
      };
    },
    getReport() {
      let params = {
        user_no: this.user_no,
        test_report_id: this.id,
      };
      Report.getReports({ ...params }, (res, err) => {
        this.loading = true;
        if (!err) {
          let arr = this.objToArray(res.chronic_disease);
          let diseasalist = [];
          arr.forEach((e) => {
            e.exam_references = e.exam_references
              ? e.exam_references.replace(/\\r\\n/g, "<br>")
              : e.exam_references;
            e.experts_science = e.experts_science
              ? e.experts_science.replace(/\\r\\n/g, "<br>")
              : e.experts_science;
            e.showCon = false;
            e.btntxt = "查看建议";
          });
          this.datas = {
            organs: arr,
            sex: res.sex,
            marks: res.marks,
          };
          diseasalist.push(...arr);
          this.diseasalist = diseasalist.sort(this.compare("order"));
          this.specials = res.special.map((e) => {
            e.desc = e.desc.replace(/\\r\\n/g, "<br>");
            e.showCon = false;
            e.btntxt = "查看建议";
            return e;
          });
          this.noHealth = false;
          this.sex = res.sex;
          this.marks = res.marks;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.organ {
  min-height: calc(100% - 20px);
  padding-bottom: 20px;
}
.nodata {
  position: relative;
  width: 640px;
  margin: auto;
  text-align: left;
  padding: 60px 0;
  line-height: 50px;
}
.nodata p {
  margin-bottom: 20px;
  margin-top: 0;
}
</style>